import { defineComponent as _defineComponent } from 'vue'
import MainlandGiftPack from './components/mainland-gift-pack/index.vue';
import PayTaskModule from './components/pay-task-module/index.vue';
import { useGlobalBi } from '@/hooks/use-global-bi';
import { CustomException, elk } from '@tencent/ppd-base-libs';
import { to } from '@tencent/wphk-base-utils';
import { onMounted, toRefs } from 'vue';
import { useMerchantInfo } from '../../../store/merchant-info-module';
import { getUrlParamByKey, UrlParamKey } from '../../../utils/url-params-helper';
import { useActConfigStore } from './store/act-config';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { getBiExt } = useGlobalBi();
const { spId, merchantId } = useMerchantInfo();
const actType = getUrlParamByKey(UrlParamKey.actType);
const { targetActConfig } = toRefs(useActConfigStore());
const { init } = useActConfigStore();

onMounted(async () => {
  const [err] = await to(init({ actType, spId }));
  if (err) {
    new CustomException(err, 'loadMainlandActConfigFail', '加载内地活动配置失败');
    return;
  }
  if (targetActConfig.value) {
    // 内地活动模块曝光上报
    elk({
      key: 'mainlandActModuleBrow',
      str3: spId,
      str4: merchantId,
    });
  }
});

return { __sfc: true,getBiExt, spId, merchantId, actType, targetActConfig, init, MainlandGiftPack, PayTaskModule }
}

})